// #region Imports

import chroma from 'chroma-js';
import { generateMaterialPalette } from './material';

// #endregion

/**
 * Generates a complementary color palette based on the given base color.
 * @param baseHex
 * @returns
 */
export function generateComplementaryPalette(baseHex: string): Record<string, string> {
    const [h, s, l] = chroma(baseHex).hsl();
    const complementaryH = (h + 180) % 360;
    return generateMaterialPalette(chroma.hsl(complementaryH, s, l).hex());
}

/**
 * Generates a single complementary color based on the given base color.
 * @param baseHex
 * @returns
 */
export function generateComplementaryColor(baseHex: string): string {
    const [h, s, l] = chroma(baseHex).hsl();
    const complementaryH = (h + 180) % 360;
    return chroma.hsl(complementaryH, s, l).hex();
}
